import { storeToRefs } from 'pinia';
import { computed, Ref, watchEffect } from 'vue';
import { usePartnerStore } from '#src/store/partner';

export function usePartner(partnerKey: Ref<string>) {
  const partnerStore = usePartnerStore();
  const { inProgress: inProgressList, partners } = storeToRefs(partnerStore);

  const partner = computed(() => partners.value[partnerKey.value]);
  const inProgress = computed(() => Boolean(inProgressList.value[partnerKey.value]));

  function getPartner() {
    return partnerStore.getPartner(partnerKey.value);
  }

  watchEffect(() => {
    if (partnerKey.value && !partner.value) {
      void getPartner();
    }
  });

  return {
    getPartner,
    inProgress,
    partner,
  };
}
